import React from 'react';
import FaqSection from '../common/FaqSection';
import { CALENDAR_FAQS } from '../../data/ipoCalendarData';

export const CalendarFaq = () => (
  <FaqSection
    id="calendar-faq"
    title="Frequently Asked Questions About the IPO Timetable"
    subtitle="Bidding windows, registrar allotment timelines and UPI mandate rules, explained."
    faqs={CALENDAR_FAQS}
  />
);

export default CalendarFaq;
